import React from "react";

export const PROMPT_HUB_STEPS = [
  { id: 1, label: "Step 1", title: "Basic Details" },
  { id: 2, label: "Step 2", title: "Configuration" },
  { id: 3, label: "Step 3", title: "Review & Publish" },
];

export const PromptHubStepLayout = ({
  title,
  steps = PROMPT_HUB_STEPS,
  currentStep,
  setCurrentStep,
  children,
  onBack,
  onNext,
  onSubmit,
  onExit,
  exitLabel = "Back",
  submitLabel = "Publish",
  submitContent,
  showQuickSave = false,
  quickSaveLabel = "Save changes",
}) => {
  const isLastStep = currentStep === steps.length;

  return (
    <div className="row login-start prompt-hub-shell">
      <div className="col-12">
        <div className="login-layout login-layout--centered prompt-hub-layout">
          <section className="login-form-panel login-form-panel--centered auth-flip-card glass-panel setting-login auth-register-panel prompt-hub-panel">
            <div className="login-form-header">
              {onExit ? (
                <div className="mb-3">
                  <button
                    type="button"
                    className="simple-btn register-back-btn auth-register-actions__button--secondary"
                    onClick={onExit}
                  >
                    {exitLabel}
                  </button>
                </div>
              ) : null}
              <p className="login-form-eyebrow">{title}</p>
            </div>

            <div className="auth-stepper" aria-label={`${title} steps`}>
              {steps.map((step) => {
                const isActive = step.id === currentStep;
                const isCompleted = step.id < currentStep;

                return (
                  <button
                    key={step.id}
                    type="button"
                    className={`auth-stepper__item${isActive ? " is-active" : ""}${isCompleted ? " is-complete" : ""}`}
                    onClick={() => setCurrentStep(step.id)}
                  >
                    <span className="auth-stepper__dot">{step.id}</span>
                    <span className="auth-stepper__copy">
                      <span className="auth-stepper__label">{step.label}</span>
                      <span className="auth-stepper__title">{step.title}</span>
                    </span>
                  </button>
                );
              })}
            </div>

            <div className="auth-register-flow prompt-hub-flow">{children}</div>

            <div className="login-action-stack auth-register-actions">
              <div className="auth-register-actions__row">
                {currentStep > 1 ? (
                  <button
                    type="button"
                    className="simple-btn register-back-btn auth-register-actions__button auth-register-actions__button--secondary"
                    onClick={onBack}
                  >
                    Back
                  </button>
                ) : (
                  <span
                    className="auth-register-actions__button prompt-hub-action-spacer"
                    aria-hidden="true"
                  />
                )}

                <div style={{ display: "flex", gap: "0.5rem" }}>
                  {showQuickSave && !isLastStep ? (
                    <button
                      type="button"
                      className="simple-btn register-back-btn auth-register-actions__button auth-register-actions__button--secondary"
                      onClick={onSubmit}
                    >
                      {quickSaveLabel}
                    </button>
                  ) : null}
                  {isLastStep ? (
                    <button
                      type="button"
                      className="simple-btn login-btn form-hidden login-submit-btn auth-register-actions__button"
                      onClick={onSubmit}
                    >
                      {submitContent || submitLabel}
                    </button>
                  ) : (
                    <button
                      type="button"
                      className="simple-btn login-btn form-hidden login-submit-btn auth-register-actions__button"
                      onClick={onNext}
                    >
                      Next
                    </button>
                  )}
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};
